import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import { contentPropTypes, linkPropTypes } from '../../../propTypes';
import { acknowledgementLoadPropTypes, labelsPropTypes } from './PropTypes';

import {
  ContentTypes,
  Features,
  Image,
  SplitImage,
  SplitVideo,
  Text,
  Video,
} from '../ContentComponents';
import { withErrorBoundary } from '../Core/ErrorBoundary';

const propTypes = exact({
  button: linkPropTypes.isRequired,
  content: PropTypes.arrayOf(contentPropTypes),
  data: acknowledgementLoadPropTypes,
  labels: labelsPropTypes,
});

const defaultProps = {
  content: undefined,
  data: undefined,
  labels: undefined,
};

function BookingPayment({ data, labels, content, button }) {
  return (
    <div className="Confirmation">
      <div className="Confirmation_content">
        <div className="Confirmation_column">
          <div className="Confirmation_wysiwyg">
            <h3>{labels.congratulationsText.replace('{Name}', data.leadBookerName)}</h3>
            <h3>{`${labels.bookingReferenceText}: ${
              data.agentCode ? data.agentCode : labels.noAgentCodeText
            }`}</h3>
            <h3>{`${labels.paymentReferenceText}: ${data.transactionReference}`}</h3>
          </div>

          {content?.map((contentItem) => {
            let component = null;

            switch (contentItem.contentType.toLowerCase()) {
              case ContentTypes.Text:
                component = <Text {...contentItem.properties} />;
                break;
              case ContentTypes.Features:
                component = <Features {...contentItem.properties} />;
                break;
              case ContentTypes.Image:
                component = <Image {...contentItem.properties} />;
                break;
              case ContentTypes.Video:
                component = <Video {...contentItem.properties} />;
                break;
              case ContentTypes.SplitImage:
                component = <SplitImage {...contentItem.properties} />;
                break;
              case ContentTypes.SplitVideo:
                component = <SplitVideo {...contentItem.properties} />;
                break;
              default:
            }

            return (
              <div key={contentItem.id} className="Confirmation_wysiwyg">
                {component}
              </div>
            );
          })}

          {button && (
            <div className="ButtonCta">
              <a href={button.url} title={button.title} className="Button Button-ghost">
                <span className="Button_text">{button.title}</span>
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

BookingPayment.propTypes = propTypes;
BookingPayment.defaultProps = defaultProps;

export default withErrorBoundary(BookingPayment);
